import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SpeakerService } from '../speaker.service';
import ErrorBarsPlugin from 'chartjs-plugin-error-bars';
import tooltip = L.tooltip;

@Component({
	selector: 'change',
	templateUrl: './change.component.html',
	styleUrls: ['./change.component.css']
})
export class ChangeComponent implements OnInit {
	@ViewChild('bar') bar: ElementRef;
	constructor(private speakerSrv: SpeakerService) { }

	@Output() onChartClick = new EventEmitter();

	// PLOT DATA VARIABLE
	plotData;
	counts;

	corpus: string[] = ['1994', '2014'];


	// DATA OPTIONS
	options = {
		legend: {
			display: false
		},
		plugins: {
			chartJsPluginErrorBars: {
				color: 'rgba(0, 0, 0, 0.1)',
				width: '5%'
			}
		},
		plugin: [ErrorBarsPlugin],
		scales: {
			yAxes: [{
				ticks: {
					min: 0,
					max: 0,
					beginAtZero: true
				},
				scaleLabel: {
					display: true,
					labelString: 'Relative Frequency per 10,000'
				}
			}],
			xAxes: [{
				barPercentage: 8,
				categoryPercentage: 0.1,
				ticks: {
					callback: (value, index, values) => {
						return 'BNC ' + value;
					}
				}
			}]
		},
		tooltips: {
			enabled: true,
			mode: 'single',
			displayColors: false,
			callbacks: {
				title: function (tooltipItem, data) {
					return 'BNC ' + data.datasets[tooltipItem[0].index].label;
				},
				label: function (tooltipItem, data) {
					let datasetLabel = Number(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
					let count = Number(data.datasets[tooltipItem.datasetIndex].counts[tooltipItem.index]);
					if (datasetLabel != 0) {
						let i = 2;
						while (Number(d3.format(',.0' + i + 'f')(datasetLabel).replace(",", "")) == 0) {
							i++;
						}
						return d3.format(',.0' + i + 'f')(datasetLabel) + " (" + count + ")";
					}
					return d3.format(',.02f')(datasetLabel) + " (" + count + ")";
				}
			}
		}
	};


	public barChartOptions: any = {
		scaleShowVerticalLines: false,
		responsive: true
	};

	public barChartLabels: string[] = [];
	public barChartType: string = 'bar';
	public barChartLegend: boolean = true;
	public barColors: any[];

	ngOnInit(): void {
		this.speakerSrv.statsChange.subscribe(stats => { this.update(stats); });
		this.barColors = [];
		let ctx = this.bar.nativeElement.getContext('2d');
		let grad1 = ctx.createLinearGradient(0, 0, 0, 200);
		grad1.addColorStop(0, 'rgb(105,130,231)');
		grad1.addColorStop(1, 'rgb(125,222,238)');

		let grad2 = ctx.createLinearGradient(0, 0, 0, 200);
		grad2.addColorStop(0, 'rgb(233,105,210)');
		grad2.addColorStop(1, 'rgb(247,126,151)');

		this.barColors.push({ backgroundColor: grad1, hoverBackgroundColor: grad1 });
		this.barColors.push({ backgroundColor: grad2, hoverBackgroundColor: grad2 });
	}

	getStandardError(array) {
		const n = array.length

		if (n == 0)
			return 0;

		const mean = array.reduce((a, b) => a + b) / n
		return Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n ** 2)
	}

	update(stats) {
		console.log(stats)
		this.plotData = [{ label: '1994', data: [], errorBars: {}, counts: [] }, { label: '2014', data: [], errorBars: {}, counts: [] }];

		let deviations = { '1994': [], '2014': [] };

		// If array is not empty
		if (Object.keys(stats).length > 0) {
			//Set Keys to the chart type
			let keys = this.corpus;

			// Create an object that has the total value of all the keys added together
			var obj = keys.reduce(function (acc, cur, i) {
				acc[cur] = { 'rel': 0, 'count': 0, 'abs': 0 };
				return acc;
			}, {});

			// Assign Corpus Total Dictionary to categorise data.

			// For each data label (1994, 2014)
			for (let i = 0; i < keys.length; i++) {
				// Assign Label to L
				let l = keys[i];
				// Create an object for each dataset
				const objKeys = Object.keys(stats[l]);
				// Add data to the corpus total
				for (let j = objKeys.length - 1; j >= 0; j--) {
					// Get stats on one person
					let g = stats[l][objKeys[j]];
					if (g['relative'] == null) {
						// do nothing
					} else {
						obj[l]['rel'] += g['relative'];
						obj[l]['abs'] += g['count'];
						deviations[l].push(g['relative']);
						obj[l]['count'] += 1;
					}

				}

				this.plotData[i].data.push(obj[l]['rel'] / obj[l]['count']);
				this.plotData[i * -1 + 1].data.push(0);

				this.plotData[i].counts.push(obj[l]['abs']);
				this.plotData[i * -1 + 1].counts.push(0);
			}
		}

		for (let i = 0; i < this.corpus.length; i++) {
			let year = this.corpus[i];

			console.log(deviations[year])

			let standard_deviation = this.getStandardError(deviations[year]);
			this.plotData[i].errorBars[year] = { plus: standard_deviation, minus: -standard_deviation }

			let value = this.plotData[i].data[i]

			let max_value = this.roundUp(value + standard_deviation)

			if (max_value > this.options.scales.yAxes[0].ticks.max)
				this.options.scales.yAxes[0].ticks.max = max_value;
		}
	}

	roundUp(value) {
		let multiplier = Math.pow(10, Math.floor(Math.log10(value)));
		return Math.ceil(value / multiplier) * multiplier;
	}

	public chartClicked(event: any) {
		if (event.active.length > 0) {
			let chartElement = event.active[0]._chart.getElementAtEvent(event.event);
			console.log(chartElement[0]._model.datasetLabel);
			let newEvent = {
				element: {
					_model: {
						datasetLabel: chartElement[0]._model.datasetLabel,
						label: chartElement[0]._model.label
					}
				}
			};
			this.speakerSrv.changeView('Concordance', event);
			this.speakerSrv.concordanceCorpusFilter.next(newEvent);
		}
	}
}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/change/change.component.ts